import React from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import Table from "examples/Tables/Table";
import BoardTableData from "Views/Curriculum/data/boardTableData";
import ArgonButton from "components/ArgonButton";
import DeleteDialog from "components/DeleteDialog/DeleteDialog";
import { useState } from "react";
import axios from "utils/api";
import { baseURL } from "utils/api";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Divider,
} from "@mui/material";
import { Close } from "@mui/icons-material";

function index() {
  const [refresh, setRefresh] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  // Add/Edit dialog state
  const [formOpen, setFormOpen] = useState(false);
  const [formMode, setFormMode] = useState("add");
  const [editId, setEditId] = useState(null);
  const [boardName, setBoardName] = useState("");
  const [formLoading, setFormLoading] = useState(false);

  // Delete button click handler
  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setDeleteDialog(true);
  };

  // Close dialog
  const handleCloseDialog = () => {
    setDeleteDialog(false);
    setDeleteId(null); // reset selected id
  };

  const handleAddClick = () => {
    setFormMode("add");
    setBoardName("");
    setEditId(null);
    setFormOpen(true);
  };

  const handleEditClick = (id, name) => {
    setFormMode("edit");
    setEditId(id);
    setBoardName(name || "");
    setFormOpen(true);
  };

  const handleCloseForm = () => {
    setFormOpen(false);
    setFormLoading(false);
    setBoardName("");
    setEditId(null);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (!boardName.trim()) {
      toast.error("Board name cannot be empty");
      return;
    }
    setFormLoading(true);
    if (formMode === "add") {
      axios
        .post(`${baseURL}/boards`, { name: boardName })
        .then((res) => {
          toast.success(res.data?.message || "Board added successfully");
          setRefresh((p) => !p);
          handleCloseForm();
        })
        .catch((err) => toast.error(err.response?.data?.error || "Failed to add board"))
        .finally(() => setFormLoading(false));
    } else {
      axios
        .put(`${baseURL}/boards/${editId}`, { name: boardName })
        .then((res) => {
          toast.success(res.data?.message || "Board updated successfully");
          setRefresh((p) => !p);
          handleCloseForm();
        })
        .catch((err) => toast.error(err.response?.data?.error || "Failed to update board"))
        .finally(() => setFormLoading(false));
    }
  };

  const handleConfirmDelete = () => {
    axios
      .put(`${baseURL}/boards/${deleteId}`, { isDeleted: true })
      .then((res) => {
        toast.success(res.data?.message || "Board deleted successfully");
        setRefresh((prev) => !prev);
        handleCloseDialog();
      })
      .catch((err) => {
        toast.error(err.response?.data?.error || "Failed to delete board");
      });
  };
  const { columns, rows } = BoardTableData(handleDeleteClick, handleEditClick, refresh);
  return (
    <ArgonBox>
      <ArgonBox display="flex" justifyContent="space-between" alignItems="center" px={4} mb={3}>
        <ArgonTypography variant="h6" size="small">
          All Board
        </ArgonTypography>
        <ArgonButton variant="contained" color="primary" size="small" onClick={handleAddClick}>
          Add Board
        </ArgonButton>
      </ArgonBox>
      <ArgonBox
        sx={{
          "& .MuiTableRow-root:not(:last-child)": {
            "& td": {
              borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                `${borderWidth[1]} solid ${borderColor}`,
            },
          },
        }}
      >
        {rows.length > 0 ? (
          <Table columns={columns} rows={rows} />
        ) : (
          <ArgonBox textAlign="center" py={4}>
            <ArgonTypography variant="h6" color="text" fontWeight="medium">
              No board found
            </ArgonTypography>
            <ArgonTypography variant="caption" color="secondary">
              Click &apos;Add Board&apos; to create a new board.
            </ArgonTypography>
          </ArgonBox>
        )}
      </ArgonBox>

      <DeleteDialog
        open={deleteDialog}
        onClose={handleCloseDialog}
        onConfirm={handleConfirmDelete}
        title="Delete Board"
        description="Are you sure you want to delete this board?"
        confirmText="Delete Board"
        cancelText="Cancel"
      />

      {/* Add/Edit Board Dialog */}
      <Dialog open={formOpen} onClose={handleCloseForm} maxWidth="sm" fullWidth>
        <DialogTitle>
          <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
            <ArgonTypography variant="h5">
              {formMode === "add" ? "Add Board" : "Edit Board"}
            </ArgonTypography>
            <IconButton onClick={handleCloseForm} size="small">
              <Close />
            </IconButton>
          </ArgonBox>
        </DialogTitle>
        <Divider />
        <form onSubmit={handleFormSubmit}>
          <DialogContent>
            <ArgonBox mb={2}>
              <ArgonTypography variant="caption" fontWeight="medium" mb={1}>
                Board Name
              </ArgonTypography>
              <ArgonBox
                component="input"
                type="text"
                value={boardName}
                onChange={(e) => setBoardName(e.target.value)}
                placeholder="Enter Board Name"
                disabled={formLoading}
                sx={{
                  width: "100%",
                  padding: "10px 12px",
                  border: "1px solid #d2d6da",
                  borderRadius: "8px",
                }}
              />
            </ArgonBox>
          </DialogContent>
          <DialogActions>
            <ArgonButton
              onClick={handleCloseForm}
              variant="outlined"
              color="secondary"
              disabled={formLoading}
            >
              Cancel
            </ArgonButton>
            <ArgonButton type="submit" variant="contained" color="primary" disabled={formLoading}>
              {formMode === "add"
                ? formLoading
                  ? "Adding..."
                  : "Add Board"
                : formLoading
                ? "Updating..."
                : "Update Board"}
            </ArgonButton>
          </DialogActions>
        </form>
      </Dialog>
    </ArgonBox>
  );
}

export default index;
